import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { palette } from '../MyTheme';

const propTypes = {
    tooltipTitle: PropTypes.string,
    tooltipDescription: PropTypes.string,
}

const useStyles = makeStyles(theme => ({
    iconTooltip: {
        '&.MuiIconButton-sizeSmall': {
            padding: 0,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '0.8125rem'
        },
        color: palette.primary.main,
    },
    infoIconTooltip: {
        '&.MuiIconButton-sizeSmall': {
            paddingLeft: theme.spacing(0.25),
        },
    },
    infoIconChip: {
        border: `1px solid lightgray`,
        backgroundColor: 'white',
        '@media (max-width: 270px)': {
            '& .MuiIconButton-label': {
                paddingBottom: '3px'
            }
        }
    },
    chip: {
        '& .MuiChip-label': {
            display: 'flex',
            '@media (max-width: 270px)': {
                flexDirection: 'column',
            },
        },
        margin: `${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    labelText: {
        fontWeight: 600,
        color: palette.primary.main,
    },
    tooltipTitle: {
        color: palette.primary.main,
    }
}))

const ChipWithTooltip = ({ tooltipTitle, tooltipDescription }) => {
    const classes = useStyles()

    return (
        <Chip
            variant="outlined"
            label={
                <>
                    <span className={classes.labelText}>{tooltipDescription}</span>
                    <Tooltip
                        title={<span className={classes.tooltipTitle}>{tooltipTitle}</span>}
                        className={`${classes.iconTooltip} ${classes.infoIconTooltip}`}
                    >
                        <IconButton size="small">
                            <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </>
            }
            className={`${classes.chip} ${classes.infoIconChip}`}
        />
    )
}

ChipWithTooltip.propTypes = propTypes

export default ChipWithTooltip